import React, { lazy } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
// import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
// import { Security, LoginCallback } from "@okta/okta-react";
import CorsErrorModal from "./CorsErrorModal";
import config from "./config";
import Project from "../projects";
import NavBar from "../navbar";
import Permissions from "../permissions";
import Preference from "../preference";
import ConfigDetails from "../configDetail";
import Loader from "../loader";
import SecureRoute from "./SecureRoute";
import IpSecureRoute from "./IpSecureRoute";

// const oktaAuthConfig = new OktaAuth(config.oidc);
const ShowPkgs = lazy(() => import("../pkgs"));
const ShowTags = lazy(() => import("../tags"));
const Config = lazy(() => import("../config/Config"));
const Size = lazy(() => import("../size/Size"));
const PkgsRevi = lazy(() => import("../revision"));
const ImpactPartner = lazy(() => import("../impactPartner/IpLandingPage"));
const IpConfigurator = lazy(() => import("../impactPartner/IpConfigPage"));
const IpSizing = lazy(() => import("../impactPartner/IpSizePage"));

// Okta instances
// const oktaAuthConfig = new OktaAuth({ ...config.oidc }); // INTERNAL
// const extOktaAuthConfig = new OktaAuth({ ...config.ip_oidc }); // EXTERNAL

const SSO = () => {
  const [corsErrorModalOpen, setCorsErrorModalOpen] = React.useState(false);
  const navigate = useNavigate();

  // const refreshFunction = (event) => {
  //   event.preventDefault();
  //   setTimeout(() => {
  //     navigate('/')
  //   }, 2000)
  // }

  // window.addEventListener("load", refreshFunction)

  // const restoreOriginalUri = (_oktaAuth, originalUri) => {
  //   navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  // }

  return (
    <>
      <NavBar {...{ setCorsErrorModalOpen }} />
      <CorsErrorModal {...{ corsErrorModalOpen, setCorsErrorModalOpen }} />
      <Routes>
        <Route element={<SecureRoute />}>
          <Route path="/" element={<Project />} />
          <Route path="permissions" element={<Permissions />} />
          <Route path="pkgs" element={<ShowPkgs />} />
          <Route path="rev" element={<PkgsRevi />} />
          <Route path="tags" element={<ShowTags />} />
          <Route path="config" element={<Config />} />
          <Route path="size" element={<Size />} />
          <Route path="config-detail" element={<ConfigDetails />} />
          <Route path="punchout" element={<ImpactPartner />} />
          <Route path="punchout/config" element={<IpConfigurator />} />
          <Route path="punchout/size" element={<IpSizing />} />
          <Route path="preference" element={<Preference />} />
        </Route>
      </Routes>
    </>
  )
};

export default SSO;
